<template>
  <a-layout :class="['admin-layout', 'beauty-scroll',isHiddenMenu&&isInWujie?'sub-app-container':'']">
    <drawer v-if="isMobile"
            v-model="drawerOpen">
      <side-menu :theme="theme.mode"
                 :menu-data="menuData"
                 :collapsed="false"
                 :collapsible="false"
                 @menuSelect="onMenuSelect" />
    </drawer>
    <side-menu v-else-if="(layout === 'side' || layout === 'mix') && !isHiddenMenu"
               :class="[fixedSideBar ? 'fixed-side' : '']"
               :theme="theme.mode"
               :menu-data="menuDataList"
               :collapsed="collapsed"
               :collapsible="true"
               :count="count"
               @toggleCollapse="toggleCollapse" />
    <a-layout class="admin-layout-main beauty-scroll">
      <a-layout-header v-if="!isHiddenMenu"  v-show="fixedHeader"
                       :class="['virtual-header', {'fixed-tabs' : fixedTabs, 'fixed-header': fixedHeader, 'multi-page': multiPage}]"></a-layout-header>
      <admin-header
        v-if="!isNoLogin && (!isHiddenMenu || !isInWujie) && !onlyGpsPage"
        :class="[{'fixed-tabs': fixedTabs, 'fixed-header': fixedHeader, 'multi-page': multiPage}]"
        :style="headerStyle"
        :menu-data="headMenuData"
        :collapsed="collapsed"
        :account-list="accountList"
        :title="pageTitle"
        :org-name-account-list="orgNameAccountList"
        @onChange="onChange"
        @toggleCollapse="toggleCollapse"
        @onSearch="onSearch" />
      <a-layout-content class="admin-layout-content" :class="isHiddenMenu&&!isInWujie&&!onlyGpsPage?'top-padding':''" :style="mainStyle">
        <div v-if="fixedSideBar && !isMobile"
             :style="`width: ${sideMenuWidth}; min-width: ${sideMenuWidth};max-width: ${sideMenuWidth};`"
             class="virtual-side"></div>
        <div style="position: relative">
          <slot></slot>
        </div>
      </a-layout-content>
      <!-- <a-layout-footer style="padding: 0px">
        <page-footer :link-list="footerLinks" :copyright="copyright" />
      </a-layout-footer> -->
    </a-layout>
    <a-icon v-if="layout !== 'head'" class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggleCollapse"/>
    <!-- <div v-if="showNew" class="new-png">
      <img src="@/assets/img/new_year.png" />
      <a-icon class="close" type="close" @click="onClosePng" />
    </div> -->
    <noticeDialog v-if="!isHiddenMenu"></noticeDialog>
  </a-layout>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { EventBus } from '@/utils/event-bus'
import {getI18nKey,redirectPath} from '@/utils/routerUtil'
import { useWujieMethod } from "@/utils/subWujie/method";
import noticeDialog from "@/layouts/noticeDialog";
import AdminHeader from './header/AdminHeader'
import Drawer from '../components/tool/Drawer'
import SideMenu from '../components/menu/SideMenu'
// import Setting from '../components/setting/Setting'
import { getUserButtonList, organizationList, getReplenishmentCustomer } from './header/api'

const orderList = '/order/manage'

export default {
  name: 'AdminLayout',
  // components: {Setting, SideMenu, Drawer, AdminHeader},
  components: {SideMenu, Drawer, AdminHeader, noticeDialog},
  data () {
    return {
      isInWujie: false,
      minHeight: window.innerHeight - 64,
      collapsed: false,
      showSetting: false,
      drawerOpen: false,
      accountList: [],
      customer: '',
      menuDataList: [],
      orgNameAccountList: [],
      showNew: true,
    }
  },
  provide() {
    return {
      adminLayout: this,
    }
  },
  computed: {
    ...mapState('setting', [
      'isMobile',
      'theme',
      'layout',
      'footerLinks',
      'copyright',
      'fixedHeader',
      'fixedSideBar',
      'fixedTabs',
      'hideSetting',
      'multiPage',
      'count'
    ]),
    ...mapGetters('setting', ['firstMenu', 'subMenu', 'menuData']),
    ...mapGetters('iframe', ['isHiddenMenu','isNoLogin', 'onlyGpsPage']),
    sideMenuWidth() {
      return this.collapsed ? '64px' : '264px'
    },
    pageTitle() {
      return this.routeName
    },
    routeName() {
      const route = this.$route
      return this.$t(getI18nKey(route.matched[route.matched.length - 1].path))
    },
    headerStyle() {
      const width =
        this.fixedHeader && this.layout !== 'head' && !this.isMobile && !this.isHiddenMenu
          ? `calc(100% - ${this.sideMenuWidth})`
          : '100%'
      const position = this.fixedHeader ? 'fixed' : 'static'
      return `width: ${width}; position: ${position};`
    },
    mainStyle() {
      const width =
        this.fixedHeader && this.layout !== 'head' && !this.isMobile && !this.isHiddenMenu
          ? `calc(100% - ${this.sideMenuWidth})`
          : '100%'
      return `min-height: ${this.minHeight}px; width: ${width};margin-left: ${!this.isHiddenMenu?this.sideMenuWidth:0};`
    },
    headMenuData() {
      const { layout, menuData, firstMenu } = this
      return layout === 'mix' ? firstMenu : menuData
    },
    sideMenuData() {
      const { layout, menuData, subMenu } = this
      return layout === 'mix' ? subMenu : menuData
    },
    accountId() {
      return this.$store.state.user.userId
    },
    sourcePath() {
      return this.$store.state.iframe.sourcePath
    }
  },
  watch: {
    $route(val) {
      this.setActivated(val)
    },
    layout() {
      this.setActivated(this.$route)
    },
    isMobile(val) {
      if (!val) {
        this.drawerOpen = false
      }
    },
  },
  async created() {
    // eslint-disable-next-line no-underscore-dangle
    this.isInWujie = window.__POWERED_BY_WUJIE__
    // eslint-disable-next-line no-underscore-dangle
    if(this.isHiddenMenu && window.__POWERED_BY_WUJIE__) { // 内嵌且又是无界触发主应用通知
      const { INJECT_SET_TASK_VISIBLE } =useWujieMethod()
      EventBus.$on("taskPopover", () => {
        INJECT_SET_TASK_VISIBLE()
      });
    }
     // 系统来源未WMS就不请求相关接口
    if(this.isNoLogin) return
    this.showNew = !localStorage.getItem('onCloseNew')
    // 获取智能补货count
    this.getReplenishmentCount()
    // this.setCount(12)
    this.correctPageMinHeight(this.minHeight - 24)
    this.setActivated(this.$route)
    if(this.$store.state.user.customerId){
      const resData = await this.organizationList(this.accountId)
      this.accountList = resData
      this.orgNameAccountList = this.accountList
      // const accountData = JSON.parse(localStorage.getItem('accountData'))
      let accont = null
      // if(accountData){
      //   accont = accountData
      // } else {

        this.accountList.forEach((e) => {
        if(!e.corpCustomer){
          if(e?.identityOrg?.identityId === this.$store.state.user.customerId){
          accont = {
            id: e.id,
            identityId: e?.identityOrg?.identityId
          }
          localStorage.setItem('customerName', e.name)
        }
        }
      })
      // }
      if(accont){
        localStorage.setItem('accountData', JSON.stringify({
          id: accont.id,
          identityId: accont.identityId
      }))
      }
    } else {
      const resData = await this.organizationList(this.accountId)
      this.accountList = resData
      this.orgNameAccountList = this.accountList
    }
    this.getUserFunctionTree()
    this.getUserButtonList(this.accountId)
    this.getOrderConfigCenterPage()
  },
  beforeDestroy() {
    this.correctPageMinHeight(-this.minHeight + 24)
  },
  methods: {
    ...mapMutations('setting', ['correctPageMinHeight', 'setActivatedFirst', 'setCollapsed', 'setCount']),
    ...mapActions('user', ['login']),
    ...mapActions('orderRules', ['getOrderConfigCenterPage']),
    ...mapMutations('user', ['SET_BUTTON_PERMISSION']),
    async getReplenishmentCount() {
      const res = await getReplenishmentCustomer()
      this.setCount(res.length)
    },
    onClosePng() {
      this.showNew = false;
      localStorage.setItem('onCloseNew', true)
    },
    menuList(menuData) {
      return menuData.map((e, i) => {
        if (e.children && e.children.length > 0) {
          return {
            ...e,
            name: `kaid${i}`,
            children: this.menuList(e.children),
          }
        }
        return {
          ...e,
          name: `over${i}`,
        }
      })
    },
    async onChange(company) {
      const userData = this.$store.state.user
      const form = {
        clientCode: 'customer_account',
        userId: userData.userId,
      }
      if(company.corpCustomer){
         form.creditCode=company.creditCode
      }else{
        localStorage.setItem('accountData',JSON.stringify({id:company.id,identityId:company.identityOrg.identityId,}))
        form.customerId=company.identityOrg.identityId
      }
      await this.login({form, type: 'resetlogin'})
      const {menuData,customerId,creditCode} = this.$store.state.user
      if(!customerId&&!creditCode){
        this.$router.push(menuData[0]?.path)
      } else if(!this.filterPath(menuData, false) && this.$route.path !== orderList){
        if(this.filterPath(menuData, true)){
          this.$router.push(orderList)
        } else if(menuData[0]?.children.length > 0){
          this.$router.push(menuData[0]?.children[0]?.path)
        } else {
          this.$router.push(menuData[0]?.path)
        }
      }
      this.$router.replace({path:redirectPath()})
      if(this.sourcePath) {
        this.$router.push(this.sourcePath)
      }
      setTimeout(()=>{
        this.$router.go(0)
      },100)
      this.loading = false
    },
    async onSearch(value) {
      const resData = await this.organizationList(this.accountId, value)
      this.orgNameAccountList = resData
    },
    async organizationList(accountId, value = null) {
      const data = {
        accountId,
        orgType: 'ORG',
        // relationType: 'DOWN',
        accountType: 'CUSTOMER',
        unionConditionLike: value,
        needOrgIdentity: true,
        needChildren: true
      }
      const res = await organizationList(data)
      EventBus.$emit('searchUser',{data:res,onlyShow:!!value})
      return res
    },
    getUserFunctionTree() {
      this.menuDataList = this.$store.state.user.menuData
    },
    filterPath(res, val) {
      let url
      if(!val){
        url = this.$route.path
      } else {
        url = orderList
      }
      let flag = false
      for (let i = 0; i < res.length; i += 1) {
        if (res[i].path === url) {
          flag = true
          break
        }
        flag = flag || this.filterPath(res[i].children, val)
      }
      return flag
    },
    getUserButtonList(accountId) {
      const {customers,customerId} = this.$store.state.user;
      const params = {
        accountId,
        admin: this.$store.state.user.admin,
        systemCode: 'customer',
        functionTypes: ['BUTTON'],
        status: 'ENABLED',
      }
      if(customers&&customers.length){
        params.objIds = customers.map(item=>item.customerId)
      }else{
        params.objId = customerId
      }
      getUserButtonList(params).then((res) => {
        localStorage.setItem('buttonPermission', JSON.stringify(res))
        this.SET_BUTTON_PERMISSION(res)
        EventBus.$emit('onLoad')
      })
    },
    toggleCollapse() {
      this.collapsed = !this.collapsed
      this.setCollapsed(this.collapsed)
    },
    onMenuSelect() {
      this.toggleCollapse()
    },
    setActivated(route) {
      if (this.layout === 'mix') {
        let { matched } = route
        matched = matched.slice(0, matched.length - 1)
        const {firstMenu} = this
        // for (const menu of firstMenu) {
        //   if (matched.findIndex(item => item.path === menu.fullPath) !== -1) {
        //     this.setActivatedFirst(menu.fullPath)
        //     break
        //   }
        // }
        firstMenu.forEach(menu => {
          if (matched.findIndex(item => item.path === menu.fullPath) !== -1) {
            this.setActivatedFirst(menu.fullPath)
          }
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-layout-sider {
  box-shadow: 4px 0px 16px 2px rgba(0, 25, 55, 0.3);
  border-radius: 0px 20px 20px 0px;
}
/deep/ .ant-menu-inline-collapsed {
  width: 60px;
  .ant-menu-item {
    padding: 0 !important;
    .anticon {
      width: 100%;
    }
    // &:hover {
    //   background: hsla(0,0%,100%,.2);
    // }
  }
  .ant-menu-submenu {
    .ant-menu-submenu-title {
      padding: 0 !important;
      .anticon {
        width: 100%;
      }
    }
  }
}
// /deep/ .ant-menu-submenu-title {
//   margin-left: -10px;
// }
.admin-layout {
  .anticon {
    display: none;
  }
  .side-menu {
    &.fixed-side {
      position: fixed;
      height: 100vh;
      left: 0;
      top: 0;
      overflow: visible;
      z-index: 101;
    }
  }
  .virtual-side {
    transition: all 0.2s;
  }
  .virtual-header {
    transition: all 0.2s;
    opacity: 0;
    &.fixed-tabs.multi-page:not(.fixed-header) {
      height: 0;
    }
  }
  .admin-layout-main {
    min-width: 1160px;
    .admin-header {
      top: 0;
      right: 0;
      overflow: hidden;
      transition: all 0.2s;
      &.fixed-tabs.multi-page:not(.fixed-header) {
        height: 0;
      }
    }
  }
  .admin-layout-content {
    background: #f4f5f6;
    // padding: 10px 30px 30px;
    /*overflow-x: hidden;*/
    /*min-height: calc(100vh - 64px - 122px);*/
  }
  .setting {
    background-color: @primary-color;
    color: @base-bg-color;
    border-radius: 5px 0 0 5px;
    line-height: 40px;
    font-size: 22px;
    width: 40px;
    height: 40px;
    box-shadow: -2px 0 8px @shadow-color;
  }
}
.new-png {
  position: fixed;
  z-index: 999;
  left: 0px;
  bottom: 56px;
  img {
    width: 196px;
    height: 140px;
  }
  .close {
    font-size: 12px;
    position: absolute;
    left: 200px;
    width: 12px;
    height: 12px;
    display: inline-block;
    color: #979797;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.ant-layout-content.top-padding {
  padding-top: 64px;
}
  .sub-app-container {
    min-width: 1200px;
    background-color: #FFFFFF;
    .tabs-view-content {
      background-color: #FFFFFF!important;
    }
    .page-content {
      padding: 8px 8px 8px 0!important;
    }
    .ant-layout-content {
      min-height: auto!important;
      background: #FFFFFF!important;
      padding-top: 0px;
      .taskBox {
        margin: 0;
        padding: 0;
      }
    }
  }
</style>
